package com.pincer.core.functions

import com.pincer.core.Logger
import com.pincer.core.YouAreNotAllowed
import com.pincer.core.model.tree.Pincer
import com.pincer.core.model.tree.PincerType
import com.pincer.core.model.tree.PincerType.STANDARD
import com.pincer.core.model.tree.PincerType.TEMPLATE
import com.pincer.core.model.tree.Participant
import com.pincer.core.model.tree.Question
import com.pincer.core.model.tree.Answer
import com.pincer.core.model.tree.LIFECYCLE_SCOPE
import com.pincer.core.model.tree.NAME_SCOPE
import com.pincer.core.model.tree.DESCRIPTION_SCOPE
import com.pincer.core.model.tree.CHATS_SCOPE
import com.pincer.core.model.tree.QUESTIONS_SCOPE
import com.pincer.core.model.tree.SELECTED_SCOPE
import com.pincer.core.model.tree.PARTICIPATIONS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ANSWERS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ROLES_SCOPE
import com.pincer.core.model.tree.CANDIDATES_SCOPE
import com.pincer.core.model.tree.PERMISSIONS_SCOPE
import com.pincer.core.model.tree.RULES_SCOPE
import com.pincer.core.model.patches.PincerPatch
import com.pincer.core.InvalidData
import com.pincer.core.contracts.TERMS_LAST_CHANGED_AT_MILLIS
import kotlin.time.Clock

fun checkPermission(pincer: Pincer?, scope: String, write: Boolean, roles: String?): Boolean {
    if (pincer == null || roles == null) return false
    for (role in roles.split(",")) {
        for (permission in pincer.permissions.values) {
            if (permission.role == role && permission.scope == scope && (!write || permission.write)) {
                return true
            }
        }
    }
    return false
}

fun checkPermissionForParticipant(pincer: Pincer?, scope: String, write: Boolean, principalId: String?): Boolean
    = checkPermission(pincer = pincer, scope = scope, write = write, roles = getRolesForParticipant(pincer = pincer, principalId = principalId))

fun assertPermission(pincer: Pincer?, scope: String, write: Boolean, roles: String?) {
    if (checkPermission(pincer = pincer, scope = scope, write = write, roles = roles)) return
    throw YouAreNotAllowed()
}

fun assertPermissionForParticipant(pincer: Pincer?, scope: String, write: Boolean, principalId: String)
    = assertPermission(pincer = pincer, scope = scope, write = write, roles = getRolesForParticipant(pincer = pincer, principalId = principalId))

// Checking patches and trimming for participants: see Access.kt
